import { useSelector } from 'hooks/redux';
import AppPageMain from 'modules/app-page/app-page--main';
import PageHeader from 'modules/page-header';
import { TabsContainer } from '@ru-digital-assets/ui-component';
import { SignersTab, DocumentsTab, MainTab } from './components';
import { useMemo, useState, useCallback } from 'react';
import { useLocation } from 'react-router';

const getTabs = (isAdmin: boolean, isOperator: boolean) => {
  const tabs = [
    {
      name: 'Основные настройки',
      id: 'main',
      key: 'main',
      Component: MainTab,
    },
  ];

  if (isAdmin && isOperator) {
    tabs.push({
      name: 'Дополнительно инструменты',
      id: 'documents',
      key: 'documents',
      Component: DocumentsTab,
    });
  }

  if (isOperator) {
    tabs.push({
      name: 'Исполнители',
      id: 'signers',
      key: 'signers',
      Component: SignersTab,
    });
  }

  return tabs;
};

const ProfileCompany = () => {
  const auth = useSelector((state) => state.auth.account);
  const company = useSelector((s) => s.companiesInfo.companies[auth.id]);
  const isAdmin = useSelector((s) => s.auth.profile.role) === 'ADMIN';
  const isOperator = useSelector(
    (state) => state.auth.profile.id === 1000000
  );

  const location = useLocation<{ tab: string }>();
  const [activeTab, setActiveTab] = useState(location.state?.tab || 'main');

  const onTabChange = useCallback((newTabID: string) => {
    setActiveTab(newTabID);
  }, []);

  const tabs = useMemo(() => {
    return getTabs(isAdmin, isOperator);
  }, [isAdmin, isOperator]);

  return (
    <AppPageMain>
      <div className="container profile-company">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader
              items={[
                {
                  link: '',
                  title: company?.shortName,
                },
              ]}
              isHideBalanceInformer={isOperator}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <TabsContainer
              tabs={tabs}
              activeTabId={activeTab}
              onTabChange={onTabChange}
              activeBackgroundColor="#F8F9FA"
            />
          </div>
        </div>
      </div>
    </AppPageMain>
  );
};

export default ProfileCompany;
